export const TABLE_DATA_TYPE = Symbol('data');
export const TABLE_NODATA_TYPE = Symbol('nodata');
export const TABLE_FLEX_TYPE = Symbol('flex');
